module.exports = __webpack_public_path__ + "fonts/montserrat-light-webfont.6225f3ca44b83090833064727a09cc95.woff?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/font/montserrat-light-webfont.woff
// module id = 737
// module chunks = 9